<template>
  <div class="organization-item" :class="itemClass">
    <div class="row">
      <div class="col-sm-6 col-xs-12">
        <b>
          <router-link :to="{ name: 'organization-view', params: { id: organization.id } }">
            {{ organization.name }}
          </router-link>
        </b>
      </div>
      <div class="col-sm-3 col-xs-6">
        <span style="color: #888">ИНН:</span> {{ organization.inn || '-' }}
      </div>
      <div class="col-sm-3 col-xs-6">
        <span style="color: #888">ОГРН:</span> {{ organization.ogrn || '-' }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-xs-12 overflow-block">
        <span :title="organization.full_name">
          {{ organization.full_name || '-' }}
        </span>
      </div>
      <div class="col-sm-6 col-xs-12 overflow-block">
        <span :title="organization.juristic_address">
          <span style="color: #888">Адрес:</span> {{ organization.juristic_address || '-' }}
        </span>
      </div>
    </div>
    <div class="row" style="margin-top: 8px; align-items: center;">
      <div class="col-sm-4 col-xs-4">
        <span style="color: #888">Телефон:</span> {{ organization.phone || '-' }}
      </div>
      <div class="col-sm-4 col-xs-4">
        <span style="color: #888">Руководитель:</span> {{ organization.name_of_manager || '-' }}
      </div>
      <div class="col-sm-4 col-xs-4 text-right">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="editOrganization"
        >
          Редактировать
        </button>
      </div>
    </div>
    <div v-if="organization.docs_status" class="row status-row">
      <div class="col-sm-12">
        <span class="docs-status-badge" :class="statusBadgeClass">
          {{ statusLabel }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'

const DOC_STATUS_CONFIG = {
  requires_documents: {
    label: 'Требуются документы',
    badge: 'badge-secondary'
  },
  under_review: {
    label: 'На рассмотрении',
    badge: 'badge-primary'
  },
  clarification_required: {
    label: 'Требуется уточнение',
    badge: 'badge-warning'
  },
  documents_accepted: {
    label: 'Документы приняты',
    badge: 'badge-success'
  }
}

export default {
  name: 'OrganizationListItem',

  mixins: [mainMixin],

  props: {
    organization: { type: Object, required: true }
  },

  computed: {
    statusConfig() {
      return DOC_STATUS_CONFIG[this.organization.docs_status] ?? null
    },

    statusLabel() {
      return this.statusConfig?.label ?? ''
    },

    statusBadgeClass() {
      return this.statusConfig?.badge ?? ''
    },

    itemClass() {
      return {
        'organization-item--warning': this.organization.docs_status === 'clarification_required'
      }
    }
  },

  methods: {
    editOrganization() {
      this.$router.push({ name: 'organization-edit', params: { id: this.organization.id } })
    }
  }
}
</script>

<style scoped>
.organization-item {
  background: #ffffff;
  border: 1px solid #e8eaf0;
  border-radius: 12px;
  padding: 18px 20px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
}

.organization-item:hover {
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.12);
  border-color: #c7c9f5;
  transform: translateY(-1px);
}

.organization-item--warning {
  border-color: #ffc107;
  background: #fffdf0;
}

.organization-item--warning:hover {
  border-color: #e0a800;
  box-shadow: 0 4px 16px rgba(255, 193, 7, 0.2);
}

.organization-item:last-child {
  margin-bottom: 0;
}

.overflow-block {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-row {
  margin-top: 10px;
}

.docs-status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.badge-secondary {
  background: #e9ecef;
  color: #495057;
}

.badge-primary {
  background: #cce5ff;
  color: #004085;
}

.badge-warning {
  background: #fff3cd;
  color: #856404;
}

.badge-success {
  background: #d4edda;
  color: #155724;
}
</style>
